import React, { createContext, useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getInstagramPosts } from '@/services/coloc-api/marketplace';

const useGetInstagramPosts = () => {
  const fetchInstagramPosts = useQuery({
    queryKey: ['getInstagramPosts'],
    queryFn: () => getInstagramPosts(),
  });

  const instagramPosts = fetchInstagramPosts?.data?.data || [];

  return {
    fetchInstagramPosts,
    instagramPosts,
  };
};

const InstagramPostsContext = createContext<ReturnType<typeof useGetInstagramPosts> | undefined>(
  undefined
);

const InstagramPostsContextProvider = ({ children }: { children: React.ReactNode }) => {
  const hook = useGetInstagramPosts();
  return <InstagramPostsContext.Provider value={hook}>{children}</InstagramPostsContext.Provider>;
};

const useInstagramPostsContext = () => {
  const context = useContext(InstagramPostsContext);
  if (context === null || context === undefined) {
    throw new Error('useInstagramPostsContext must be used within InstagramPostsContextProvider');
  }
  return context;
};

export { useInstagramPostsContext, InstagramPostsContextProvider };
